import {
  checkAndHealBundleSkew,
  defaultBundleSkewDeps,
  resetBundleSkewReloadLatchForTests,
  type BundleSkewResult,
} from './bundleSkewGuard';

const CHECK_DEBOUNCE_MS = 2000;

let inFlight = false;
let lastCheckAt = 0;
let installed = false;

export async function runBundleSkewCheck(
  deps = defaultBundleSkewDeps(),
  now = Date.now(),
): Promise<BundleSkewResult | 'debounced'> {
  if (!deps) return 'offline';
  if (inFlight || now - lastCheckAt < CHECK_DEBOUNCE_MS) return 'debounced';
  inFlight = true;
  lastCheckAt = now;
  try {
    return await checkAndHealBundleSkew(deps);
  } catch {
    return 'offline';
  } finally {
    inFlight = false;
  }
}

/** Boot + resume listeners. Idempotent. Never throws. */
export function installBundleSkewGuard(win: Window = window): void {
  if (installed) return;
  installed = true;

  const run = () => {
    void runBundleSkewCheck();
  };

  try {
    run();
    win.addEventListener('pageshow', run);
    win.addEventListener('focus', run);
    win.document.addEventListener('visibilitychange', () => {
      if (win.document.visibilityState === 'visible') run();
    });
  } catch {
    /* never abort boot */
  }
}

/** Test-only: reset debounce / install latch. */
export function resetBundleSkewGuardForTests(): void {
  installed = false;
  inFlight = false;
  lastCheckAt = 0;
  resetBundleSkewReloadLatchForTests();
}
